import React from 'react';
import { Layout } from 'antd';
const { Sider } = Layout;

export const CustomSider = (props: any) => {
  return (
    <Sider
      width={props.width}
      style={{
        backgroundColor: '#FFFFFF',
        height: '100%',
        overflow: 'hidden auto',
        borderRight: props.border === 'right' ? '1px solid #DCDCDC' : '',
        borderLeft: props.border === 'left' ? '1px solid #DCDCDC' : '',
        ...props.style,
      }}>
      {props.children}
    </Sider>
  );
};

export const SidebarSider = (props: any) => {
  return (
    <Sider
      width={props.width}
      style={{
        backgroundColor: '#FFFFFF',
        width: '100%',
        height: 'calc(100vh - 2px)',
        overflowY: 'auto',
        borderRight: '1px solid #DCDCDC',
      }}>
      {props.children}
    </Sider>
  );
};
